import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import EditTable from '../EditTable';
import { Col, Container, Row, Button, OverlayTrigger, Popover } from 'react-bootstrap';

class Checkout extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			screen: screens.swipe,
			swipe: {
				CARD_MAG: ''
			},
			user: {
				PERSON_ID: ''
			},
			speedtype: {
				SPEEDTYPE: ''
			},
			checkout: {
				SWIPE_PERSON_ID: null,
				SWIPE_PI_ROLE_ID: null,
				PERSON_ID: null,
				PI_ROLE_IDS: [],
				PI_ROLE_ID: null,
				SPEEDTYPE: null,
				checkout_details: [],
				pi_map: {},
			},
			confirm: {
				SALE_ID: null,
				GRAND_TOTAL: null
			},
			emptyCheckoutDetail: this.copyObject(emptyCheckoutDetail),
			editorsOpen: [],
			renderKey: 0
		}
	}	
	
	componentDidUpdate(prevProps) {
		var self = this;
		
		// if the user has just logged in
		if (prevProps.user.uid !== this.props.user.uid && this.props.user.uid > 0) {
			// check in to stores
			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Stores/CheckIn',
				data: { __RequestVerificationToken: this.props.user.antiForgeryToken, cardmag: this.state.swipe.CARD_MAG }
			}).done(function (data) {
				if (data.Success) {
					var newState = data.Data;
					
					newState.screen = screens.checkout;					
					newState.checkout = {
						SWIPE_PERSON_ID: newState.swipe_user.PERSON_ID,
						SWIPE_PI_ROLE_ID: newState.swipe_user.PI_ROLE_ID,
						PERSON_ID: newState.swipe_user.PERSON_ID,
						PI_ROLE_IDS: newState.swipe_user.PI_ROLE_IDS,
						PI_ROLE_ID: newState.swipe_user.PI_ROLE_ID,
						SPEEDTYPE: newState.swipe_user.DEFAULT_CC,
						checkout_details: []
					};
					
					self.mergeState(newState);
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		}
	}
		
	onEdit(accessor, editorIsOpen) {
		this.mergeState({
			editorsOpen: this.setEditorStatus(accessor, editorIsOpen),
			renderKey: this.state.renderKey + 1
		});
	}
	
	setEditorStatus(accessor, editorIsOpen) {
		var editorsOpen = this.copyObject(this.state.editorsOpen);
		if (editorIsOpen) {
			// add to list if it isn't already present
			if (!editorsOpen.includes(accessor)) editorsOpen.push(accessor);
		} else {			
			// remove from list if it is present
			if (editorsOpen.includes(accessor)) editorsOpen.splice(editorsOpen.indexOf(accessor), 1);
		}
		return editorsOpen;
	}		

	onChange(accessor, value) {
		var newState = {
			checkout: this.copyObject(this.state.checkout),
			renderKey: this.state.renderKey + 1
		};
		this.setByAccessor(newState.checkout, accessor, value);
		if (accessor === 'checkout_details') {
			newState.editorsOpen = this.setEditorStatus(accessor, false);
		} else if (accessor === 'PERSON_ID') {
			var piInfo = this.state.pi_map['' + value] || [];
			newState.checkout.PI_ROLE_IDS = [];
			newState.checkout.PI_ROLE_ID = null;
			newState.checkout.SPEEDTYPE = null;
			for (var i = 0; i < piInfo.length; i++) {
				var pipeIdx = piInfo[i].indexOf('|');
				var pi_role_id = piInfo[i].substring(0, pipeIdx);
				var speedtype = piInfo[i].substring(pipeIdx + 1);
				if (i === 0) {
					newState.checkout.PI_ROLE_ID = pi_role_id;
					newState.checkout.SPEEDTYPE = speedtype;
				}
				newState.checkout.PI_ROLE_IDS.push(pi_role_id);
			}
		}
		this.mergeState(newState);
	}
	
	onChangeCheckoutDetail(checkout_detail, accessor, value) {
		var qty = this.getNumeric(accessor === 'QTY' ? value: this.getByAccessor(checkout_detail, 'QTY'), 0);
		var price = this.getNumeric(Array.isArray(accessor) && accessor[4] === 'UNIT_COST' ? value[4] : this.getByAccessor(checkout_detail, 'UNIT_COST'), 0);
		
		this.setByAccessor(checkout_detail, 'SUB_TOTAL', qty * price);
	}
		
	onSubmit(event) {
		var self = this;
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Stores/CheckOut',
			data: { __RequestVerificationToken: this.props.user.antiForgeryToken, checkout: this.state.checkout }
		}).done(function (data) {
			if (data.Success) {
				self.mergeState({
					screen: screens.confirm,
					confirm: data.Data
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	onChangeSwipe(accessor, value) {
		var swipe = this.copyObject(this.state.swipe);
		this.setByAccessor(swipe, accessor, value);
		this.mergeState({ swipe: swipe });
	}

	onSubmitSwipe(event) {
		this.props.logIn(this.state.swipe.CARD_MAG);
	}

	render() {
		
		// create args for receipt pdf icon
		var receiptData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			saleid: this.state.confirm.SALE_ID
		});

		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						  <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Storeroom Checkout System</div>
					  </Col>
					</Row>
					{this.state.screen === screens.swipe &&
					<Row>
					  <Col>
						<ChemEdit parent={this} columns={swipeColumns} data={this.state.swipe} user={this.props.user} renderKey={this.state.renderKey} autoSubmit={true}
						   onChange={(accessor, value) => this.onChangeSwipe(accessor, value)} onSubmit={(event) => this.onSubmitSwipe(event)} editable={true} />
					  </Col>
					</Row>}
					{this.state.screen === screens.checkout && <>
					<Row>
					  <Col>
						<ChemEdit parent={this} columns={checkoutColumns} data={this.state.checkout} user={this.props.user} renderKey={this.state.renderKey} 
						   onChange={(accessor, value) => this.onChange(accessor, value)} onSubmit={(event) => this.onSubmit(event)} editable={this.state.editable} />
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<h6>Line Items</h6>
						<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={this.state.emptyCheckoutDetail} data={this.state.checkout.checkout_details}
						  tableColumns={detailTableColumns} editColumns={detailEditColumns} onEdit={(editorIsOpen) => this.onEdit('checkout_details', editorIsOpen)}
						  onChange={(data) => this.onChange('checkout_details', data)} tableName='Stores_Checkout_Detail' order='LINE_ID' editable={this.state.editable}
						  onChangeInternal={(data, accessor, value) => this.onChangeCheckoutDetail(data, accessor, value)} />
					  </Col>
					</Row>
					<Row>
					  <Col>
						<Button id="save" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmit(event)}>Purchase</Button>
					  </Col>
					</Row>
					</>}
					{this.state.screen === screens.confirm &&
					<Row>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Stores/Receipt'} method='POST'>
							{receiptData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Print Receipt" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={10} style={{ paddingBottom: '20px', paddingTop: '20px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
						Sale {this.state.confirm.SALE_ID} completed. Your grand total is {this.state.confirm.GRAND_TOTAL}. Click the PDF icon to print your receipt. Please remember to log out when you are finished.
					  </Col>
					  <Col xs={1}>
						<Button id="logout" variant="warning" type="button" className="float-end" onClick={(event) => this.logout()}>Log Out</Button>
					  </Col>
				    </Row>}
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const screens = {
	swipe: 'Swipe Card',
	checkout: 'Checkout',
	confirm: 'Confirm'
};

const swipeColumns = [
	{ Header: 'Please Swipe Card to Start', accessor: 'CARD_MAG' }
];

const checkoutColumns = [
	{ Header: 'User', accessor: 'PERSON_ID', type: 'select', row: 0, col: 0,
		options: { value: 'PERSON_ID', label: 'USER_NAME', entity: 'STORES.CHECKOUT_USER_SELECT_VW', order: ['SWIPED_AT_TOP','SORT_USER_NAME'],
			search: { Operator: 'or', Children: [
				{ Operator: 'and', Children: [
					{ Attribute: 'PERSON_ID', Operator: '=', LongAccessor: 'SWIPE_PERSON_ID' },
					{ Attribute: 'SWIPED_AT_TOP', Operator: '=', IntValue: '0' }
				]},
				{ Operator: 'and', Children: [
					{ Attribute: 'PERSON_ID', Operator: '!=', LongAccessor: 'SWIPE_PERSON_ID' },
					{ Attribute: 'SWIPED_AT_TOP', Operator: '=', IntValue: '1' }
				]}
	]}}},
	{ Header: 'PI', accessor: 'PI_ROLE_ID', type: 'select', row: 0, col: 1,
		options: { value: 'ROLE_ID', label: 'PI_NAME', entity: 'STORES.CHECKOUT_PI_SELECT_VW', order: ['USER_PI_FIRST','SORT_PI_NAME'],
			search: { Operator: 'or', Children: [
				{ Operator: 'and', Children: [
					{ Attribute: 'ROLE_ID', Operator: 'in', LongListAccessor: 'PI_ROLE_IDS' },
					{ Attribute: 'USER_PI_FIRST', Operator: '=', IntValue: '0' }
				]},
				{ Operator: 'and', Children: [
					{ Attribute: 'ROLE_ID', Operator: 'not in', LongListAccessor: 'PI_ROLE_IDS' },
					{ Attribute: 'USER_PI_FIRST', Operator: '=', IntValue: '1' }
				]}
	]}}},
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', type: 'select', row: 0, col: 2,
		options: { value: 'COST_CENTER', label: 'COST_CENTER_DISPLAY', entity: 'STORES.CHECKOUT_SPEEDTYPE_SELECT_VW', order: 'COST_CENTER',
			search: { Attribute: 'ROLE_ID', Operator: '=', LongAccessor: 'PI_ROLE_ID'
	}}}
];

const emptyCheckoutDetail = {
	LINE_ID: null,
	ITEM_ID: null,
	DESCRIPTION: '',
	QTY: 0,
	UNIT_OF_MEASURE: '',
	UNIT_COST: 0,
	SUB_TOTAL: 0,
	RESTRICTED: false
}

const detailTableColumns = [
	{ Header: 'Line', accessor: 'LINE_ID', width: 50 },
	{ Header: 'Qty', accessor: 'QTY', width: 70, align: 'right' },
	{ Header: 'Stock Number', accessor: 'STOCK_NO', width: 110 },
	{ Header: 'Description', accessor: 'DESCRIPTION', width: 300 },
	{ Header: 'Unit', accessor: 'UNIT_OF_MEASURE', width: 70 },
	{ Header: 'Price', accessor: 'UNIT_COST', width: 80, align: 'right', Cell: props => props.parent.formatCurrency(props.value) },
	{ Header: 'Total', accessor: 'SUB_TOTAL', width: 80, align: 'right', Cell: props => props.parent.formatCurrency(props.value) },
];

const detailEditColumns = [
	{ Header: 'Line', accessor: 'LINE_ID', row: 0, col: 0, editable: false },
	{ Header: 'Stock Number', accessor: 'ITEM_ID', labelAccessor: ['STOCK_NO','DESCRIPTION','UNIT_OF_MEASURE','UNIT_COST','RESTRICTED'], type: 'multicolumn', row: 0, col: 1,
		options: { value: 'ITEM_ID', label: ['STOCK_NO','DESCRIPTION','UNIT_OF_MEASURE','UNIT_COST','RESTRICTED'], entity: 'STORES.INVENTORY2', order: 'STOCK_NO',
			search: { Attribute: 'RETIRE_FLAG', Operator: 'is null' }
	}},
	{ Header: 'Description', accessor: 'DESCRIPTION', row: 0, col: 2, type: 'textarea', editable: false },
	{ Header: 'Qty', accessor: 'QTY', row: 1, col: 0 },
	{ Header: 'Unit', accessor: 'UNIT_OF_MEASURE', row: 1, col: 1, editable: false },
	{ Header: 'Price', accessor: 'UNIT_COST', row: 1, col: 2, editable: false },
	{ Header: 'Sub Total', accessor: 'SUB_TOTAL', row: 2, col: 0, editable: false },
	{ Header: 'Restricted', accessor: 'RESTRICTED', type: 'checkbox', row: 2, col: 1, editable: false }
];

export default withRouter(Checkout);
